import CustomAlert from "components/generals/alert/CustomAlert";

import React, { useState, useEffect, useContext } from "react";

import { Navigate, useNavigate } from "react-router-dom";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Box,
  TextField,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  Grid,
} from "@mui/material";
import { AuthContext } from "../authProvider/authProvider";
import Tooltip from "@mui/material/Tooltip";
import InputAdornment from "@mui/material/InputAdornment";
import InfoIcon from "@mui/icons-material/Info";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import { format, parse } from "date-fns";

import { app, host } from "../../config";
import "./enroll.css";

interface FormState {
  Sex: string;
  Tier: string;
  Plan_ID: string[];
  EmpOrDep: string;
  Reason: string;
  EmpSSN: string;
  EmpDOB: string;
  Division_ID: string;
  Date_Enrolled: string;
  Birth_Date: string;
  First_Name: string;
  Last_Name: string;
  SSN: string;
  Address: string;
  City: string;
  Zip_Code: string;
  State: string;
  Group_ID: string;
  Relationship: string;
  Card_Request: string;
}

interface IFetchedData {
  Group_ID: string;
  Division_ID: string;
  Coverage_Start: string;
  Coverage_End: string;
  Name: string;
  Benefit_Description: string;
  Description: string;
  Plan_ID: string;
}

const EmployeeEnrollmentForm: React.FC = () => {
  const [form, setForm] = useState<FormState>({
    Sex: "",
    Tier: "EM",
    Plan_ID: [],
    Division_ID: "",
    EmpOrDep: "",
    Reason: "",
    EmpSSN: "",
    EmpDOB: "",
    Date_Enrolled: "",
    Birth_Date: "",
    First_Name: "",
    Last_Name: "",
    SSN: "",
    Address: "",
    City: "",
    Zip_Code: "",
    State: "",
    Group_ID: "",
    Relationship: "",
    Card_Request: "",
  });

  //  EmpOrDep: string;
  // EmpSSN: string;
  // EmpDOB: string;

  const [planOptions, setPlanOptions] = useState<{ Description: string; Plan_ID: string }[]>([]);

  const [divisionOptions, setDivisionOptions] = useState<{ Name: string; Division_ID: string }[]>([]);

  const [planSelection, showPlanSelection] = useState<boolean>(false);

  const [divSelection, showDivSelection] = useState<boolean>(false);

  const [loading, setLoading] = useState(false);

  const [showFormDetails, setShowFormDetails] = useState(false);

  const [currentGroup, setCurrentGroup] = useState("");

  const [selectedPlans, setSelectedPlans] = useState<string[]>([]);

  const [isAlertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState<string>("");

  const [availableCoverages, setAvailableCoverages] = useState<string[]>([]);
  const [selectedCoveragePeriod, setSelectedCoveragePeriod] = useState<string>("");
  const [allPlans, setAllPlans] = useState<IFetchedData[]>([]);

  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});

  const openAlert = () => {
    setAlertOpen(true);
  };

  const closeAlert = () => {
    setAlertOpen(false);
  };

  const authContext = useContext(AuthContext);
  if (!authContext) {
    throw new Error("AuthContext is undefined");
  }
  const { currentUser, role, selectedGroup } = authContext;

  const navigate = useNavigate();

  var tk: string;
  currentUser
    ?.getIdToken(false)
    .then((idToken: string) => {
      tk = idToken;
    })
    .catch((error: any) => {
      console.log(error);
    });

  useEffect(() => {
    if (role == "broker" || role == "employer")
      currentUser
        ?.getIdToken(false)
        .then((idToken: string) => {
          tk = idToken;
          fetchData(selectedGroup);
        })
        .catch((error: any) => {
          console.log(error);
        });
  }, [selectedGroup]);

  const goToEmployeeMaintenance = () => {
    navigate("/employeeMaintenance");
  };

  function cleanString(str: string) {
    //If we need to add more protections, we can.

    const newStr = str.replace(/,/g, "");

    return newStr;
  }

  const handleChange = (event: SelectChangeEvent<{ value: unknown; name: unknown }>) => {
    const updatedForm = {
      ...form,
      [event.target.name as string]: event.target.value as string,
    };

    setForm(updatedForm);
  };

  const handleChange2 = (event: React.ChangeEvent<{ value: unknown; name: unknown }>) => {
    setForm({
      ...form,
      [event.target.name as string]: event.target.value as string,
    });
  };

  const handleNumericInput = (event) => {
    // Regex to allow only numeric input
    const value = event.target.value.replace(/[^0-9]/g, "");
    setForm({
      ...form,
      [event.target.name]: value,
    });
  };

  const handleChange5 = (event) => {
    // Handle multiple selections
    const value = event.target.value;
    const newSelectedPlans = typeof value === "string" ? value.split(",") : value;
    setSelectedPlans(newSelectedPlans);
    const updatedForm = {
      ...form,
      [event.target.name as string]: newSelectedPlans,
    };
    setForm(updatedForm);
    console.log(form);
  };

  // Function to handle API call
  const fetchData = (groupNo: string) => {
    setLoading(true);

    try {
      fetch(`${host}/api/enrollments/groupPlans?group_number=${groupNo}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${tk}`,
        },
      })
        .then((response: Response) => {
          if (response.status === 200) {
            response.json().then((resp) => {
              // Store all plans
              setAllPlans(resp.data);

              const coveragePeriods = [
                ...new Set(
                  resp.data.map((item: IFetchedData) => {
                    const startDate = format(
                      parse(item.Coverage_Start, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", new Date()),
                      "MM/dd/yyyy"
                    );
                    const endDate = format(
                      parse(item.Coverage_End, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", new Date()),
                      "MM/dd/yyyy"
                    );
                    return `${startDate} - ${endDate}`;
                  })
                ),
              ].sort((a: number, b: number) => a - b) as string[];
              setAvailableCoverages(coveragePeriods);

              setShowFormDetails(true);
            });
          } else {
            setLoading(false);

            setAlertMessage(`Error retrieving data. Please try again later. ${response.status}`);
            setAlertOpen(true);
          }
        })
        .catch((error: any) => {
          console.log(error);
        })
        .finally(() => {
          // Code to execute in the finally block
          // This will run regardless of whether an error occurred or not
          setLoading(false);
        });
      // Do something with the data
      // For example, update state or perform additional logic
    } catch (error) {
      console.error("Error:", error);

      setAlertMessage(
        `An error occurred: ${error.message}. Please verify all fields have been filled. Contact support if the issue persists.`
      );
      setAlertOpen(true);
    }
    setCurrentGroup(groupNo);
    setLoading(false);
    setForm({
      Sex: "",
      Tier: "EM",
      Plan_ID: [],
      Division_ID: "",
      EmpOrDep: "",
      Reason: "",
      EmpSSN: "",
      EmpDOB: "",
      Date_Enrolled: "",
      Birth_Date: "",
      First_Name: "",
      Last_Name: "",
      SSN: "",
      Address: "",
      City: "",
      Zip_Code: "",
      State: "",
      Group_ID: groupNo,
      Relationship: "",
      Card_Request: "",
    });
  };

  const handleButtonClick = () => {
    // Your logic for button click, perhaps using some values from state to call `fetchData`
    if (form && form.Group_ID) {
      fetchData(form.Group_ID);
    }
  };

  function resetForms() {
    setForm({
      Sex: "",
      Tier: "EM",
      Plan_ID: [],
      Division_ID: "",
      EmpOrDep: "",
      Reason: "",
      EmpSSN: "",
      EmpDOB: "",
      Date_Enrolled: "",
      Birth_Date: "",
      First_Name: "",
      Last_Name: "",
      SSN: "",
      Address: "",
      City: "",
      Zip_Code: "",
      State: "",
      Group_ID: "",
      Relationship: "",
      Card_Request: "",
    });
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    const checkRequiredFields = () => {
      const requiredFields = {
        Sex: "Gender",
        Tier: "Tier",
        EmpOrDep: "Employee or Dependent",
        Reason: "Reason For Enrollment",
        Plan_ID: "Plan",
        Division_ID: "Division",
        Date_Enrolled: "Date Enrolled",
        Birth_Date: "Date of Birth",
        First_Name: "First Name",
        Last_Name: "Last Name",
        City: "City",
        Zip_Code: "Zip Code",
        State: "State",
      };
      if (form.EmpOrDep === "Employee") {
        requiredFields["SSN"] = "SSN";
      }
      if (form.EmpOrDep === "Dependent") {
        requiredFields["Relationship"] = "Relationship";
        requiredFields["EmpDOB"] = "Employee Date of Birth";
        requiredFields["EmpSSN"] = "Employee SSN";
      }
      const emptyFields = Object.keys(requiredFields)
        .filter((field) => !form[field] || (form[field] && form[field]?.toString().trim() === ""))
        .map((key) => requiredFields[key]);
      if (emptyFields.length > 0) {
        throw new Error(`Please fill all required fields. Missing fields: ${emptyFields.join(", ")}.`);
      }
    };

    try {
      checkRequiredFields();
      const upload = { ...form };
      if (role === "broker" || role === "employer") {
        upload.Group_ID = selectedGroup;
      }
      if (upload.EmpOrDep === "Dependent") {
        // Dependent submission
        fetch(`${host}/api/enrollments/vba/subscriber/addDependents`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${tk}`,
          },
          body: JSON.stringify({ member: upload }),
        }).then((response: Response) => {
          if (response.ok) {
            setAlertMessage(`Please allow 24 hours for this enrollment to be processed.`);
            setAlertOpen(true);
            showPlanSelection(false);
            showDivSelection(false);
            setForm({
              Sex: "",
              Tier: "EM",
              Plan_ID: [],
              EmpOrDep: "",
              Reason: "",
              EmpSSN: "",
              EmpDOB: "",
              Division_ID: "",
              Date_Enrolled: "",
              Birth_Date: "",
              First_Name: "",
              Last_Name: "",
              SSN: "",
              Address: "",
              City: "",
              Zip_Code: "",
              State: "",
              Group_ID: "",
              Relationship: "",
              Card_Request: "",
            });
          } else {
            return response.text().then((resptext) => {
              try {
                const respjson = JSON.parse(resptext);
                let errorMessage: string;
                if (respjson.error) {
                  try {
                    const innerJson = JSON.parse(respjson.error);
                    errorMessage = innerJson.error;
                  } catch (innerParseError) {
                    errorMessage = respjson.error;
                  }
                } else {
                  errorMessage = resptext;
                }
                setAlertMessage(`Error: ${errorMessage}. Please contact support if the issue persists.`);
              } catch (e) {
                setAlertMessage(`Backend error: ${resptext}. Please contact support.`);
              }
              setAlertOpen(true);
            });
          }
        });
      } else {
        // Employee submission
        const subUpload = { ...upload, Relationship: "01" };
        fetch(`${host}/api/enrollments/vba/subscriber`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${tk}`,
          },
          body: JSON.stringify(subUpload),
        }).then((response: Response) => {
          if (response.ok) {
            setAlertMessage(`Please allow 24 hours for this enrollment to be processed.`);
            setAlertOpen(true);
            showPlanSelection(false);
            showDivSelection(false);
            setForm({
              Sex: "",
              Tier: "EM",
              Plan_ID: [],
              EmpOrDep: "",
              Reason: "",
              EmpSSN: "",
              EmpDOB: "",
              Division_ID: "",
              Date_Enrolled: "",
              Birth_Date: "",
              First_Name: "",
              Last_Name: "",
              SSN: "",
              Address: "",
              City: "",
              Zip_Code: "",
              State: "",
              Group_ID: "",
              Relationship: "",
              Card_Request: "",
            });
          } else {
            return response.text().then((resptext) => {
              try {
                const respjson = JSON.parse(resptext);
                let errorMessage: string;
                if (respjson.error) {
                  try {
                    const innerJson = JSON.parse(respjson.error);
                    errorMessage = innerJson.error;
                  } catch (innerParseError) {
                    errorMessage = respjson.error;
                  }
                } else {
                  errorMessage = resptext;
                }
                setAlertMessage(`Error: ${errorMessage}. Contact support if the issue persists.`);
              } catch (e) {
                setAlertMessage(`Backend error: ${resptext}. Please contact support.`);
              }
              setAlertOpen(true);
            });
          }
        });
      }
    } catch (error: any) {
      setAlertMessage(error.message || "An unexpected error occurred.");
      setAlertMessage(
        `An error occurred while processing the request: ${error.message}. Contact support if the issue persists.`
      );
      setAlertOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    const isConfirmed = window.confirm("Are you sure, Record will not be saved if you cancel");
    if (isConfirmed) {
      // Redirect to another page or perform a cancel action
      showPlanSelection(false);
      showDivSelection(false);
      setShowFormDetails(false);

      setForm({
        Sex: "",
        Tier: "EM",
        Plan_ID: [],
        Division_ID: "",
        Date_Enrolled: "",
        EmpOrDep: "",
        Reason: "",
        EmpSSN: "",
        EmpDOB: "",
        Birth_Date: "",
        First_Name: "",
        Last_Name: "",
        SSN: "",
        Address: "",
        City: "",
        Zip_Code: "",
        State: "",
        Group_ID: "",
        Relationship: "",
        Card_Request: "",
      });
      console.log("User cancelled the form.");
    }
  };

  const handleYearChange = (event: SelectChangeEvent<string>) => {
    const yearRange = event.target.value;
    const targetStartDateString = yearRange.split("-")[0].replaceAll(" ", "");
    const targetEndDateString = yearRange.split("-")[1].replaceAll(" ", "");

    setSelectedCoveragePeriod(yearRange);

    const filteredPlans = allPlans.filter((plan) => {
      const startDate = parse(plan.Coverage_Start, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", new Date());
      const endDate = parse(plan.Coverage_End, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'", new Date());
      const targStartDate = parse(targetStartDateString, "MM/dd/yyyy", new Date());
      const targetEndDate = parse(targetEndDateString, "MM/dd/yyyy", new Date());

      const isValid = startDate <= targStartDate && endDate >= targetEndDate;
      return isValid;
    });

    const uniquePlans = filteredPlans.reduce((acc: any[], plan: IFetchedData) => {
      const exists = acc.some((p) => p.Plan_ID === plan.Plan_ID);
      if (!exists) {
        acc.push({
          Description: plan.Benefit_Description || plan.Description,
          Plan_ID: plan.Plan_ID,
        });
      }
      return acc;
    }, []);

    const uniqueDivisions = filteredPlans.reduce((acc: any[], item: IFetchedData) => {
      const exists = acc.some((elem: any) => elem.Division_ID === item.Division_ID);
      if (!exists) {
        acc.push({
          Name: item.Name,
          Division_ID: item.Division_ID,
        });
      }
      return acc;
    }, []);

    setDivisionOptions(uniqueDivisions);
    showDivSelection(true);

    setPlanOptions(uniquePlans);
    showPlanSelection(true);

    setForm((prev) => ({
      ...prev,
      Plan_ID: [],
    }));
  };

  if (loading) {
    return (
      <div className="loader-container">
        <CircularProgress />
      </div>
    );
  }
  return (
    <div className="form-container">
      <Button className="navigate-button" variant="contained" onClick={goToEmployeeMaintenance}>
        Employee Maintenance
      </Button>
      <CustomAlert message={alertMessage} isOpen={isAlertOpen} onClose={closeAlert} />
      <Paper
        style={{
          width: "60%", // This will make the form take up 80% of the parent container's width.
          margin: "10px auto",
          padding: "20px",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography variant="h4" style={{ textAlign: "center", marginBottom: "30px", color: "black" }}>
          Employee Enrollment Details
        </Typography>

        <form
          onSubmit={showFormDetails ? handleSubmit : () => {}}
          style={{ backgroundColor: "#ededed", padding: "20px" }}
        >
          {role === "admin" || role === "internal_ugp" ? (
            <>
              <Tooltip title="Enter the unique group identifier">
                <TextField
                  fullWidth
                  margin="normal"
                  type="text"
                  name="Group_ID"
                  onChange={handleChange2}
                  value={form.Group_ID}
                  label="Group Number"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <InfoIcon style={{ color: "rgba(0, 0, 0, 0.54)" }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Tooltip>
              {/* Add your button here */}
              {
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    handleButtonClick();
                  }}
                >
                  Update Selections with Group ID
                </Button>
              }
            </>
          ) : (
            <>
              <Typography>Selected Group: {selectedGroup}</Typography>
            </>
          )}

          {showFormDetails && (
            <>
              {/* Year Selection */}
              <Box display="flex" alignItems="center">
                <Box display="flex" alignItems="center" style={{ width: "100%" }}>
                  <FormControl fullWidth margin="normal" style={{ flex: 1 }}>
                    <InputLabel>Coverage Period</InputLabel>
                    <Select
                      value={selectedCoveragePeriod}
                      onChange={handleYearChange}
                      label="Select Year"
                      disabled={availableCoverages.length === 0}
                    >
                      {availableCoverages.map((year) => (
                        <MenuItem key={year} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Box>

              {/* Plan Selection - only show when year is selected */}
              {selectedCoveragePeriod && (
                <Box display="flex" alignItems="center">
                  <Box display="flex" alignItems="center" style={{ width: "100%" }}>
                    <FormControl fullWidth margin="normal" style={{ flex: 1 }}>
                      <InputLabel>Plan Selection</InputLabel>
                      <Select
                        multiple
                        name="Plan_ID"
                        value={form.Plan_ID}
                        onChange={handleChange5}
                        label="Plan Selection"
                        renderValue={(selected) =>
                          selected
                            .map((planId) => {
                              const selectedPlan = planOptions.find((group) => group.Plan_ID === planId);
                              return selectedPlan ? `${selectedPlan.Description} (${selectedPlan.Plan_ID})` : planId;
                            })
                            .join(", ")
                        }
                      >
                        {planOptions.map((group) => {
                          return (
                            <MenuItem key={group.Plan_ID} value={group.Plan_ID}>
                              {group.Description}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <Tooltip title="Select the Plan the member should be enrolled in.">
                      <InfoIcon style={{ marginLeft: 10, color: "rgba(0, 0, 0, 0.54)" }} />
                    </Tooltip>
                  </Box>
                </Box>
              )}

              {/* Division Selection = only show when year is selected */}
              {selectedCoveragePeriod && (
                <Box display="flex" alignItems="center">
                  <Box display="flex" alignItems="center" style={{ width: "100%" }}>
                    <FormControl fullWidth margin="normal" style={{ flex: 1 }}>
                      <InputLabel>Division ID/Location Name</InputLabel>
                      <Select
                        name="Division_ID"
                        value={form.Division_ID as any}
                        onChange={handleChange}
                        label="Division/Location Selection"
                        renderValue={(selected) => {
                          const selectedDivision = divisionOptions.find(
                            (group) => group.Division_ID === (selected as any)
                          );
                          return selectedDivision
                            ? (`${selectedDivision.Name} (${selectedDivision.Division_ID})` as any)
                            : (selected as any);
                        }}
                      >
                        {divisionOptions.map((group) => {
                          return (
                            <MenuItem key={group.Division_ID} value={group.Division_ID}>
                              {group.Name} ({group.Division_ID})
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <Tooltip title="Select the Division or Location the member should be enrolled in.">
                      <InfoIcon style={{ marginLeft: 10, color: "rgba(0, 0, 0, 0.54)" }} />
                    </Tooltip>
                  </Box>
                </Box>
              )}

              <Box display="flex" alignItems="center">
                <Box display="flex" alignItems="center" style={{ width: "100%" }}>
                  <FormControl fullWidth margin="normal" style={{ flex: 1 }}>
                    <InputLabel>Employee or Dependent:</InputLabel>
                    <Select
                      name="EmpOrDep"
                      onChange={handleChange}
                      label="Employee or Dependent"
                      value={form.EmpOrDep as any}
                    >
                      <MenuItem key="employee" value="Employee">
                        Employee
                      </MenuItem>
                      <MenuItem key="dependent" value="Dependent">
                        Dependent
                      </MenuItem>
                    </Select>
                  </FormControl>
                  <Tooltip title="Are you enrolling an Employee or Dependent">
                    <InfoIcon style={{ marginLeft: 10, color: "rgba(0, 0, 0, 0.54)" }} />
                  </Tooltip>
                </Box>
              </Box>

              <Box display="flex" alignItems="center">
                <Box display="flex" alignItems="center" style={{ width: "100%" }}>
                  <FormControl fullWidth margin="normal" style={{ flex: 1 }}>
                    <InputLabel>Reason For Enrollment:</InputLabel>
                    <Select
                      name="Reason"
                      onChange={handleChange}
                      label="Reason For Enrollment"
                      value={form.Reason as any}
                    >
                      <MenuItem key="newHire" value="NewHire">
                        New Hire
                      </MenuItem>
                      <MenuItem key="openEnrollment" value="OpenEnrollment">
                        Open Enrollment
                      </MenuItem>
                      <MenuItem key="marriage" value="Marriage">
                        Marriage
                      </MenuItem>
                      <MenuItem key="lossOfCoverage" value="LossOfCoverage">
                        Loss Of Coverage
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>

              <FormControl fullWidth margin="normal">
                <InputLabel>Sex</InputLabel>
                <Select
                  name="Sex"
                  onChange={handleChange}
                  label="Sex"
                  value={form.Sex as unknown as any}
                  defaultValue={"" as any}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value="male">Male</MenuItem>
                  <MenuItem value="female">Female</MenuItem>
                </Select>
              </FormControl>

              {form.EmpOrDep === "Dependent" && (
                <>
                  {/* <InputLabel>Emp SSN:</InputLabel> */}
                  <TextField
                    fullWidth
                    margin="normal"
                    type="text"
                    name="EmpSSN"
                    onChange={handleNumericInput}
                    value={form.EmpSSN}
                    label="Emp SSN"
                  />

                  <Typography variant="subtitle1">Emp Date of Birth</Typography>
                  <TextField
                    fullWidth
                    margin="normal"
                    type="date"
                    name="EmpDOB"
                    onChange={handleChange2}
                    value={form.EmpDOB as string}
                  />
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Relationship</InputLabel>
                    <Select
                      name="Relationship"
                      onChange={handleChange}
                      value={form.Relationship as any}
                      defaultValue={"" as any}
                      label="Relationship"
                    >
                      <MenuItem value="19">Child</MenuItem>
                      <MenuItem value="02">Spouse</MenuItem>
                      <MenuItem value="28">Other</MenuItem>
                      <MenuItem value="28">Domestic Partner</MenuItem>
                    </Select>
                  </FormControl>
                </>
              )}

              <FormControl>
                <Typography variant="subtitle1">Effective Date of Benefits</Typography>
                <Tooltip title="">
                  <TextField
                    fullWidth
                    margin="normal"
                    type="date"
                    name="Date_Enrolled"
                    onChange={handleChange2}
                    value={form.Date_Enrolled}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <InfoIcon style={{ color: "rgba(0, 0, 0, 0.54)" }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Tooltip>
              </FormControl>

              <Typography variant="subtitle1">Date of Birth</Typography>
              <TextField
                fullWidth
                margin="normal"
                type="date"
                name="Birth_Date"
                onChange={handleChange2}
                value={form.Birth_Date}
              />

              <TextField
                fullWidth
                margin="normal"
                type="text"
                name="First_Name"
                onChange={handleChange2}
                label="First Name"
                value={form.First_Name}
              />

              <TextField
                type="text"
                name="Last_Name"
                onChange={handleChange2}
                label="Last Name"
                value={form.Last_Name}
              />

              <TextField
                fullWidth
                margin="normal"
                type="text"
                name="SSN"
                onChange={handleNumericInput}
                value={form.SSN}
                label="SSN"
              />

              <TextField
                fullWidth
                margin="normal"
                type="text"
                name="Address"
                onChange={handleChange2}
                value={form.Address}
                label="Address"
              />

              <TextField
                fullWidth
                margin="normal"
                type="text"
                name="City"
                onChange={handleChange2}
                value={form.City}
                label="City"
              />

              <TextField
                fullWidth
                margin="normal"
                type="text"
                name="Zip_Code"
                onChange={handleChange2}
                value={form.Zip_Code}
                label="Zipcode"
              />

              <FormControl fullWidth margin="normal">
                <InputLabel>State</InputLabel>
                <Select
                  name="State"
                  onChange={handleChange}
                  value={form.State as any}
                  defaultValue={"" as any}
                  label="State"
                >
                  <MenuItem value="">...Select</MenuItem>
                  <MenuItem value="AK">Alaska</MenuItem>
                  <MenuItem value="AL">Alabama</MenuItem>
                  <MenuItem value="AR">Arkansas</MenuItem>
                  <MenuItem value="AZ">Arizona</MenuItem>
                  <MenuItem value="CA">California</MenuItem>
                  <MenuItem value="CO">Colorado</MenuItem>
                  <MenuItem value="CT">Connecticut</MenuItem>
                  <MenuItem value="DE">Delaware</MenuItem>
                  <MenuItem value="FL">Florida</MenuItem>
                  <MenuItem value="GA">Georgia</MenuItem>
                  <MenuItem value="HI">Hawaii</MenuItem>
                  <MenuItem value="ID">Idaho</MenuItem>
                  <MenuItem value="IL">Illinois</MenuItem>
                  <MenuItem value="IN">Indiana</MenuItem>
                  <MenuItem value="IA">Iowa</MenuItem>
                  <MenuItem value="KS">Kansas</MenuItem>
                  <MenuItem value="KY">Kentucky</MenuItem>
                  <MenuItem value="LA">Louisiana</MenuItem>
                  <MenuItem value="ME">Maine</MenuItem>
                  <MenuItem value="MD">Maryland</MenuItem>
                  <MenuItem value="MA">Massachusetts</MenuItem>
                  <MenuItem value="MI">Michigan</MenuItem>
                  <MenuItem value="MN">Minnesota</MenuItem>
                  <MenuItem value="MS">Mississippi</MenuItem>
                  <MenuItem value="MO">Missouri</MenuItem>
                  <MenuItem value="MT">Montana</MenuItem>
                  <MenuItem value="NE">Nebraska</MenuItem>
                  <MenuItem value="NV">Nevada</MenuItem>
                  <MenuItem value="NH">New Hampshire</MenuItem>
                  <MenuItem value="NJ">New Jersey</MenuItem>
                  <MenuItem value="NM">New Mexico</MenuItem>
                  <MenuItem value="NY">New York</MenuItem>
                  <MenuItem value="NC">North Carolina</MenuItem>
                  <MenuItem value="ND">North Dakota</MenuItem>
                  <MenuItem value="OH">Ohio</MenuItem>
                  <MenuItem value="OK">Oklahoma</MenuItem>
                  <MenuItem value="OR">Oregon</MenuItem>
                  <MenuItem value="PA">Pennsylvania</MenuItem>
                  <MenuItem value="RI">Rhode Island</MenuItem>
                  <MenuItem value="SC">South Carolina</MenuItem>
                  <MenuItem value="SD">South Dakota</MenuItem>
                  <MenuItem value="TN">Tennessee</MenuItem>
                  <MenuItem value="TX">Texas</MenuItem>
                  <MenuItem value="UT">Utah</MenuItem>
                  <MenuItem value="VT">Vermont</MenuItem>
                  <MenuItem value="VA">Virginia</MenuItem>
                  <MenuItem value="WA">Washington</MenuItem>
                  <MenuItem value="WV">West Virginia</MenuItem>
                  <MenuItem value="WI">Wisconsin</MenuItem>
                  <MenuItem value="WY">Wyoming</MenuItem>
                </Select>
              </FormControl>
              <Grid container direction="column" alignItems={"center"} alignContent={"center"}>
                <Typography>Order Cards?</Typography>
                <RadioGroup
                  aria-label="position"
                  name="Card_Request"
                  value={form.Card_Request}
                  onChange={handleChange}
                  row
                >
                  <FormControlLabel value="true" control={<Radio color="primary" />} label="Yes" labelPlacement="end" />
                  <FormControlLabel value="false" control={<Radio color="primary" />} label="No" labelPlacement="end" />
                </RadioGroup>
              </Grid>

              <Button type="submit" variant="contained" className="blue-button" disabled={loading}>
                Submit
              </Button>
              <Button type="button" variant="contained" className="cancel-button" onClick={handleCancel}>
                Cancel
              </Button>
              {loading && <CircularProgress />}
            </>
          )}
        </form>
      </Paper>
    </div>
  );
};

export default EmployeeEnrollmentForm;
